import React from 'react';
const Faq = ({ faq }) => {
    return (
        <div className="bg-white shadow-md sm:rounded-lg p-4 mb-4">
            <div className="text-lg font-medium text-gray-800 mb-2">{faq.question}</div>
            <div className="text-gray-600">{faq.answer}</div>
        </div>
    );
};

const FaqList = ({ data }) => {
    return (
        <div className="space-y-4">
            {data.map((faq) => (
                <Faq key={faq.id} faq={faq} />
            ))}
        </div>
    );
};

export default FaqList;
